// extracted by mini-css-extract-plugin
export default {"headerLink":"headerLink-1ddb","header-nav-link":"header-nav-link-bc3e","dark":"dark-3399","selected":"selected-fec4"};